import { InvalidUrlError } from '@execonline-inc/url';
import { assertNever } from '@kofno/piper';
import { AppyError } from '../../Appy';
import { MissingLinkError } from '../../LinkyLinky';
import ReactionComponent, { RCProps } from '../../ReactionComponent';
import { State } from '../Types';
import ParticipantsStore from '../index';
import { load, loadMore } from './Load';

interface Props extends RCProps<ParticipantsStore> {}

export type ParticipantsError = AppyError | InvalidUrlError | MissingLinkError;

class ParticipantsReactions extends ReactionComponent<ParticipantsStore, State, Props> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'initializing':
        break;
      case 'loading':
        load(store, state);
        break;
      case 'loading-more':
        loadMore(store, state);
        break;
      case 'updating-query':
        store.ready(state.resource, state.participantStores);
        break;
      case 'updating-search-parameters':
      case 'sorting':
        store.loading(1);
        break;
      case 'ready':
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };
}

export default ParticipantsReactions;
